import { UNUSUAL_CONVERSION_ACTION } from "./constants";

const UnusualConversion = ({ id, auto = true }: { id: UNUSUAL_CONVERSION_ACTION; auto?: boolean }) => {
    return (
        <div
            unusual-conversion-id={id}
            unusual-convert-on-load={auto ? "true" : "false"}
            data-testid="auto-id-31403196-0a28-4889-8891-01ea8e97505b" />
    );
};

export default UnusualConversion;
